import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenFileUploadComponent } from "./components/loren-file-upload/loren-file-upload.component";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [LorenFileUploadComponent],
  imports: [CommonModule, MatIconModule],
  exports: [LorenFileUploadComponent],
})
export class LorenFileUploadModule {}
